import {
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
import { getRealmFromBaseLMSUrl } from "../auth-api-client";
import { studentApiRequest } from "../student-api-client";
import { encodeId } from "../util/functions-utils";
const _30_MINS = 1e3 * 30 * 60;
function fetchStudent(studentId) {
  const realmId = getRealmFromBaseLMSUrl();
  return studentApiRequest({
    url: `/student/${studentId}`,
    headers: { realm: realmId }
  }).catch((error) => {
    if ((error == null ? void 0 : error.status) == 404 || (error == null ? void 0 : error.status) === void 0) {
      console.warn("Student information not found", error);
      return {};
    }
    throw error;
  });
}
function fetchHighlight(activityId, studentId) {
  return studentApiRequest({
    url: `/student/highlights/${encodeId(activityId)}`,
    params: {
      studentId
    }
  }).catch(() => null);
}
function useStudentQuery(studentId) {
  return useQuery(["student", studentId], () => fetchStudent(studentId), {
    staleTime: _30_MINS
  });
}
function useStudentHighlightQuery(activityId, studentId) {
  return useQuery(
    ["activity", activityId],
    () => fetchHighlight(activityId, studentId),
    { enabled: !!activityId }
  );
}
function useStudentSettingsMutation() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({
      studentId,
      settings
    }) => patchStudentSettings(studentId, settings),
    onSuccess(_, { studentId }) {
      client.invalidateQueries(["student", studentId]);
    }
  });
}
function patchStudentSettings(studentId, settings) {
  return studentApiRequest({
    url: `student/${studentId}/settings`,
    method: "PATCH",
    data: settings
  });
}
function addHighlight(activityId) {
  return studentApiRequest({
    url: `/student/highlights/${encodeId(activityId)}`,
    method: "POST"
  });
}
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["STUDENT"] = "STUDENT";
  UserType2["EDUCATOR"] = "EDUCATOR";
  return UserType2;
})(UserType || {});
export {
  UserType,
  addHighlight,
  fetchStudent,
  patchStudentSettings,
  useStudentHighlightQuery,
  useStudentQuery,
  useStudentSettingsMutation
};
